/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-10 10:54:06
 * @LastEditors: caiqin.xie
 * @message: 服务支持-公共-是否有帮助组件
 */
import React, {useState} from "react";
import classNames from "classnames";
import styles from "./index.module.scss";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  className?: string;
  isLike?: boolean; // 是否喜欢
  isDislike?: boolean; // 是否不喜欢
  handleClick?: (type:string, isClink:boolean)=>void; // 点赞/点踩
}

const Rate = (props: IProps) => {
  const {ctry, words, handleClick, isLike, isDislike, className} = props
  // 2023-09-14 需求为：点踩点赞仅支持提交一次，不支持修改
  const handleLikeClick =  () => {
    if (isDislike) return
    if (!isLike) {
      handleClick('like', true)
    }
  }
  const handleDisLikeClick = () => {
    if (isLike) return
    if (!isDislike) {
      handleClick('disLike', true)
    }
  }

  return (
    <div className={`${styles['rate-wrap']} ${className}`}>
      <p>{words?.common_is_help}</p>
      <p className={styles.rate}>
        <span
          onClick={handleLikeClick}
          className={classNames(
            styles['rate-icon'],
            styles.like,
            {[styles['like_purple']]: isLike}
        )}>{words?.common_likes}</span>
        <span
          onClick={handleDisLikeClick}
          className={classNames(
            styles['rate-icon'],
            styles.dislike,
            {[styles['dislike_purple']]: isDislike}
        )}>{words?.common_dislike}</span>
      </p>
    </div>
  )
}
export default Rate